export default __webpack_public_path__ + "static/SectionTwo_02_03-acedc3d98f26e86456d99c8f00e48ccc.webp";